const { interpolateUrl } = require('./url');

const LINKS = {
    captions_ai_media: 'https://sl.spotme.com/howto-captioning',
    cms_template: 'https://sl.spotme.com/cms-template',
    download_app: 'https://sl.spotme.com/download-app',
    free_email_domains_list: 'https://sl.spotme.com/blocked-email-domains',
    getting_started: 'https://sl.spotme.com/getting-started',
    speaker_feedback_form: 'https://sl.spotme.com/studio-speaker-feedback#eid={{eventId}}&stream={{liveStreamId}}',
    studio_permissions: 'https://sl.spotme.com/studio-permissions',
    studio_screenshare: 'https://sl.spotme.com/how-to-screenshare-mac',
    webhooks: 'https://sl.spotme.com/webhooks',
    whats_new: 'https://sl.spotme.com/whats-new',

    captions_wordly: 'https://support.spotme.com/hc/en-us/articles/16068314484755-Closed-captions-and-translation-using-Wordly',
    email_type: 'https://support.spotme.com/hc/en-us/articles/360058286333-Making-sure-that-participants-receive-your-event-emails#h_01HRPTT3CNBF20J0A2BCSCM0PF',
    event_status: 'https://support.spotme.com/hc/en-us/articles/5289615998355-Managing-a-workspace-s-production-status-Test-Preproduction-Production',
    firewall_network_requirements: 'https://support.spotme.com/hc/en-us/articles/360051642033',
    firewall_settings: 'https://support.spotme.com/hc/en-us/articles/360051642033-SpotMe-platform-corporate-firewall-network-requirements',
    fp_type_limits: 'https://support.spotme.com/hc/en-us/articles/4408591514131',
    hive_streaming: 'https://support.spotme.com/hc/en-us/articles/29749606817555-SpotMe-partners-with-Hive-Streaming',
    hybrid_events: 'https://support.spotme.com/hc/en-us/articles/10096307255187-Hybrid-events-participants-attending-virtually-and-in-person',
    live_stream_troubleshooting: 'https://support.spotme.com/hc/en-us/articles/360047591593-Troubleshooting-for-live-stream-production',
    manual_user_approval: 'https://support.spotme.com/hc/en-us/articles/38707188381971-How-can-attendee-s-retrieve-access-an-existing-registration-for-an-event#h_01JVCPNPDESBZP53Q547NKBHH8',
    metadata_cc_field: 'https://support.spotme.com/hc/en-us/articles/40463108037139-Allowing-your-attendees-to-provide-a-secondary-contact-email-associated-with-their-user-profile',
    metadata_editor: 'https://support.spotme.com/hc/en-us/articles/34643855803795-Using-the-Metadata-manager-updated-user-interface',
    requirements: 'https://support.spotme.com/hc/en-us/articles/4413459400723-SpotMe-platform-user-technical-requirements#h_01FT8RRDNCD9EB7BKXNR2MGS4W',
    rtmps_streaming_section: 'https://support.spotme.com/hc/en-us/sections/360007968334',
    signal_wss_blocked: 'https://support.spotme.com/hc/en-us/articles/360051642033-Domain-allow-list-and-split-tunneling-on-corporate-networks',
    speaker_preparation: 'https://support.spotme.com/hc/en-us/articles/360047006233-Preparing-your-speakers-for-a-virtual-meeting',
    // API doc links
    api_guide: 'https://support.spotme.com/hc/en-us/sections/30040214476435-Build-your-custom-integration',
    usage_recommendations: 'https://support.spotme.com/hc/en-us/articles/35763840837395-How-to-use-the-host-or-speaker-blurred-background-and-noise-removal-in-Studio',
    registration_page_utm_tracking: 'https://support.spotme.com/hc/en-us/articles/9003222618643-How-to-track-where-users-are-coming-from-when-registering'
};

/**
 * Returns a link URL for given name
 *
 * @param {string} name
 * @returns {string} link URL
 */
export function getLinkUrl(name, replacements = {}) {
    return interpolateUrl(LINKS[name], replacements);
}
